import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { cn } from "../../utils/twMerge";
import rawConfig from "./configData";
import DropdownList from "./DropdownList";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { chevronDownIcon } from "../../assetData/icons";
import { errorNotify } from "../../Services/Notification";
import axios from "axios";
import { workingFinYearAPIUrl } from "../../Services/tradeConsultantUrl";
import DropdownListMobile from "./DropDownListMobile";
import {
  getRawConfigs,
  actionPermissionsService,
  actionPermService,
  actionPermFuncService,
  actionPermLinkFuncService,
} from "../../utils/permissionsService.js";

export const actionPermissions = actionPermissionsService;
export const actionPerm = actionPermService;
export const actionPermFunc = actionPermFuncService;
export const actionPermLinkFunc = actionPermLinkFuncService;

function AuthNavbar() {
  const [navToggle, setNavToggle] = useState(false);
  const [activeHoveMenuItem, setaAtiveHoveMenuItem] = useState("");
  const [activeHoveMenuShow, setaAtiveHoveMenuShow] = useState(false);

  const subscriberName = sessionStorage.getItem("subscriberName");
  const selectedRadio = sessionStorage.getItem("selectedRadio");
  const finYearList = JSON.parse(sessionStorage.getItem("Finyear_List"));

  const payload =
    sessionStorage.getItem("selectedRadio") === "group"
      ? { selected_group_id: Number(sessionStorage.getItem("subscriberId")) }
      : sessionStorage.getItem("selectedRadio") === "family"
      ? { selected_family_id: Number(sessionStorage.getItem("subscriberId")) }
      : "";

  const navigate = useNavigate();
  const location = useLocation();
  const prevState = location.state || {};

  const workingFinYearCall = location?.state?.workingFinYear;

  const finYearID = sessionStorage.getItem("subFinYearID")
    ? Number(sessionStorage.getItem("subFinYearID"))
    : Number(sessionStorage.getItem("finYearID"));

  const finYearName = sessionStorage.getItem("finYearName");

  const apiOption = {
    data: payload,
    headers: {
      Authorization: `Bearer ${
        sessionStorage.getItem("subscriberToken")
          ? sessionStorage.getItem("subscriberToken")
          : sessionStorage.getItem("token")
      }`,
    },
  };
  const getWorkingFinYear = async () => {
    try {
      const res = await axios.get(workingFinYearAPIUrl, apiOption);
      if (res?.data) {
        const resData = res?.data?.data;
        if (resData) {
          sessionStorage.setItem("finYearName", resData?.Working_fin_year);
          sessionStorage.setItem("finYearID", resData?.id);
          sessionStorage.setItem(
            "finYear",
            resData?.Working_fin_year?.split(" ")[1],
          );
          navigate(location.pathname, {
            replace: true,
            state: { ...prevState, workingFinYear: false },
          });
        }
      }
    } catch (error) {
      console.error();
    }
  };

  useEffect(() => {
    if (workingFinYearCall) {
      getWorkingFinYear();
    }
  }, [workingFinYearCall]);

  const rawConfigs = getRawConfigs();

  const firstName = JSON.parse(sessionStorage.getItem("user"))?.first_name;
  const lastName = JSON.parse(sessionStorage.getItem("user"))?.last_name;
  const handleNavbarAccess = () => {
    if (finYearID && finYearName) {
    } else {
      errorNotify("Please Select Starting Financial Year From");
    }
  };

  // CONTRACT NOTE FILTERING
  useEffect(() => {
    const contractNotePaths = [
      "/i9fSJE2qImNDOTT7Uk3GmmwoDSi6zWymK/5hS7woDsk=",
      "/HryxAFjeBb3ZtFtds9fwgO4GOLm7yrxVMpqb++ABLaU=",
      "/qh394zOLEyk/TiykgMk5ui6t+ql6X7aOjjGFVcewMgM=",
      "/3JhrXN3bmBfzUNb7cWtYxu4GOLm7yrxVMpqb++ABLaU=",
    ];

    const corporateActionPath = [
      "/PU0/e35qQerVMTEDtjXjD4F3Jhc2XqlVKJDMAkOconI=",
    ];

    return () => {
      if (!contractNotePaths.includes(window.location.pathname)) {
        sessionStorage.removeItem("contractBroker");
        sessionStorage.removeItem("Contract Note");
        sessionStorage.removeItem("uploadedFrom");
        sessionStorage.removeItem("uploadedTo");
        sessionStorage.removeItem("tradeDateFrom");
        sessionStorage.removeItem("tradeDateTo");
      }
      if (!corporateActionPath.includes(window.location.pathname)) {
        sessionStorage.removeItem("CorporateActionMaster");
        sessionStorage.removeItem("corporate_action");
        sessionStorage.removeItem("ca_master_scrip");
        sessionStorage.removeItem("ex_from");
        sessionStorage.removeItem("ex_to");
        sessionStorage.removeItem("caa_status");
      }
    };
  }, [window.location.pathname]);
  return (
    <div className="">
      <nav
        className={`fixed left-0 right-0 top-0 z-[1000] w-full bg-[#231C42] px-[2%]`}
      >
        <div
          className={` ${
            selectedRadio
              ? " mx-[20px] mt-[20px] h-[60px] items-start"
              : " mx-[20px] h-[80px] items-center "
          }  min-lg:px-[16px] flex  max-w-[98%] justify-between md:px-0`}
        >
          <div
            className={`${
              selectedRadio ? "items-start" : "items-center"
            } flex  justify-start`}
          >
            <div className="min-w-[134px]">
              <Link
                onClick={() => {
                  finYearID && finYearName
                    ? setNavToggle(false)
                    : handleNavbarAccess();
                }}
                to={finYearID && finYearName ? "/" : false}
              >
                <img
                  className="min-w-[134px]"
                  src="/images/logo.png"
                  alt="Logo"
                />
              </Link>
            </div>

            <div className="desktop-navbar">
              <ul className="hidden items-center justify-center gap-8 px-12 lg:flex [&>li]:relative [&>li]:w-max [&>li]:cursor-pointer [&>li]:uppercase [&>li]:text-white ">
                {Object.keys(rawConfigs)
                  ?.filter((item) => item !== "logged user")
                  .map((menuName, index) => (
                    <div
                      key={index}
                      className="relative w-max cursor-pointer uppercase text-white"
                    >
                      <li
                        className={cn(
                          "relative whitespace-nowrap  hover:text-[#428DCB]",
                          {
                            "after:absolute after:left-0 after:top-[2em] after:hidden after:h-[4px] after:w-[40px] after:bg-[#428DCB] hover:after:block":
                              index !== 0,
                          },
                        )}
                        onClick={() =>
                          finYearID && finYearName
                            ? false
                            : handleNavbarAccess()
                        }
                        onMouseEnter={() =>
                          finYearID && finYearName
                            ? setaAtiveHoveMenuItem(menuName)
                            : false
                        }
                        onMouseLeave={() => setaAtiveHoveMenuItem("")}
                      >
                        {menuName}
                        {activeHoveMenuItem === menuName &&
                          menuName !== "logged user" && (
                            <>
                              <DropdownList
                                data={rawConfigs[menuName]}
                                handleClose={() => setaAtiveHoveMenuItem("")}
                                routeName={rawConfigs[menuName]}
                                subscriberName={subscriberName}
                              />
                            </>
                          )}
                      </li>
                    </div>
                  ))}
              </ul>
            </div>
          </div>

          <div className="desktop-navbar">
            <ul
              className={`hidden items-center justify-center gap-8 px-12 lg:flex [&>li]:relative [&>li]:w-max [&>li]:cursor-pointer [&>li]:uppercase [&>li]:text-white `}
            >
              {Object.keys(rawConfigs)
                .filter((item) => item === "logged user")
                .map((menuName, index) => (
                  <div
                    key={index}
                    className="relative flex w-max cursor-pointer justify-end space-x-5 whitespace-nowrap uppercase text-white"
                  >
                    {menuName === "logged user" && (
                      <>
                        {sessionStorage.getItem("subscriberToken") && (
                          <li>
                            <div
                              className="relative flex w-full items-center gap-0 space-x-2"
                              onMouseEnter={() =>
                                finYearID && finYearName
                                  ? setaAtiveHoveMenuItem(menuName)
                                  : false
                              }
                            >
                              <div className="flex h-[25px] w-[25px] items-center rounded-sm bg-[#231c42] p-1  ">
                                {selectedRadio === "member" && (
                                  <>
                                    <svg
                                      fill="white"
                                      width={"13px"}
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 448 512"
                                    >
                                      <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z" />
                                    </svg>
                                  </>
                                )}
                                {selectedRadio === "family" && (
                                  <svg
                                    fill="white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 640 512"
                                  >
                                    <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z" />
                                  </svg>
                                )}

                                {selectedRadio === "group" && (
                                  <svg
                                    fill="white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 640 512"
                                  >
                                    <path d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z" />
                                  </svg>
                                )}
                              </div>
                              {selectedRadio === "member" && (
                                <p
                                  className=" text-[16px]  text-white"
                                  onClick={() =>
                                    finYearID && finYearName
                                      ? false
                                      : handleNavbarAccess()
                                  }
                                >
                                  {subscriberName}
                                </p>
                              )}
                              {selectedRadio === "family" && (
                                <p
                                  className=" text-[16px] text-white"
                                  onClick={() =>
                                    finYearID && finYearName
                                      ? false
                                      : handleNavbarAccess()
                                  }
                                >
                                  {subscriberName}
                                </p>
                              )}
                              {selectedRadio === "group" && (
                                <p
                                  className=" text-[16px] text-white"
                                  onClick={() =>
                                    finYearID && finYearName
                                      ? false
                                      : handleNavbarAccess()
                                  }
                                >
                                  {subscriberName}
                                </p>
                              )}
                              <img
                                src={chevronDownIcon}
                                alt="i4invest"
                                className=""
                              />
                            </div>
                            {activeHoveMenuItem === menuName &&
                              menuName === "logged user" &&
                              selectedRadio && (
                                <div className="">
                                  <DropdownList
                                    selectedRadio={selectedRadio}
                                    data={rawConfigs[menuName]}
                                    handleClose={() =>
                                      setaAtiveHoveMenuItem("")
                                    }
                                    subscriberName={subscriberName}
                                    routeName={menuName}
                                  />
                                </div>
                              )}
                          </li>
                        )}
                        <li
                          className={cn("relative hover:text-[#428DCB]", {
                            "after:absolute after:left-0 after:top-[2em] after:hidden after:h-[4px] after:w-[40px] after:bg-[#428DCB] hover:after:block":
                              index !== 0,
                          })}
                          onClick={() =>
                            finYearID && finYearName
                              ? false
                              : handleNavbarAccess()
                          }
                          onMouseEnter={() =>
                            finYearID && finYearName
                              ? setaAtiveHoveMenuItem("finyear")
                              : false
                          }
                          onMouseLeave={() => setaAtiveHoveMenuItem("")}
                        >
                          {selectedRadio === "group" ||
                          selectedRadio === "family" ? (
                            <>
                              <div className="flex items-center">
                                <p className="mr-2">{finYearName}</p>
                                <img
                                  src={chevronDownIcon}
                                  alt="i4invest"
                                  className=""
                                />
                              </div>
                              {activeHoveMenuItem === "finyear" && (
                                <DropdownList
                                  data={rawConfig?.finyear}
                                  handleClose={() => setaAtiveHoveMenuItem("")}
                                  routeName="finyear"
                                  workingFinYear={finYearName}
                                  finYearList={finYearList}
                                  subscriberName={subscriberName}
                                />
                              )}
                            </>
                          ) : (
                            <>
                              <div className="flex items-center">
                                <p className="mr-2">{finYearName}</p>
                                <img
                                  src={chevronDownIcon}
                                  alt="i4invest"
                                  className=""
                                />
                              </div>
                              {activeHoveMenuItem === "finyear" && (
                                <DropdownList
                                  data={rawConfig?.finyear}
                                  handleClose={() => setaAtiveHoveMenuItem("")}
                                  routeName="finyear"
                                  workingFinYear={finYearName}
                                  finYearList={finYearList}
                                  subscriberName={subscriberName}
                                />
                              )}
                            </>
                          )}
                        </li>
                        <li
                          className={cn("relative hover:text-[#428DCB]", {
                            "after:absolute after:left-0 after:top-[2em] after:hidden after:h-[4px] after:w-[40px] after:bg-[#428DCB] hover:after:block":
                              index !== 0,
                          })}
                          onClick={() =>
                            finYearID && finYearName
                              ? false
                              : handleNavbarAccess()
                          }
                          onMouseEnter={() =>
                            finYearID && finYearName && !selectedRadio
                              ? setaAtiveHoveMenuItem(menuName)
                              : false
                          }
                          onMouseLeave={() => setaAtiveHoveMenuItem("")}
                        >
                          <div className="flex items-center">
                            <p className="mr-2">
                              {menuName === "logged user"
                                ? firstName + " " + lastName
                                : menuName}
                            </p>
                            {!selectedRadio && (
                              <img
                                src={chevronDownIcon}
                                alt="i4invest"
                                className=""
                              />
                            )}
                          </div>
                          {selectedRadio && (
                            <>
                              <p className="absolute text-[9px] italic">
                                ( Currently logged in as
                              </p>
                              <p className="absolute mt-[16px] text-[9px] italic">
                                {subscriberName})
                              </p>
                            </>
                          )}
                          {activeHoveMenuItem === menuName &&
                            menuName === "logged user" && (
                              <>
                                {!selectedRadio && (
                                  <DropdownList
                                    data={rawConfigs[menuName]}
                                    handleClose={() =>
                                      setaAtiveHoveMenuItem("")
                                    }
                                    routeName={menuName}
                                  />
                                )}
                              </>
                            )}
                        </li>
                      </>
                    )}
                  </div>
                ))}
            </ul>
          </div>

          {navToggle ? (
            <AiOutlineClose
              onClick={() => setNavToggle(!navToggle)}
              className="text-2xl text-[#fff] lg:hidden"
            />
          ) : (
            <AiOutlineMenu
              onClick={() => setNavToggle(!navToggle)}
              className="text-2xl text-[#fff] lg:hidden"
            />
          )}

          {/* Responsive Menu */}
          <ul
            className={`fixed top-[80px] h-screen w-[100%] overflow-scroll bg-[#231C42] duration-300 lg:hidden ${
              navToggle ? "left-[0]" : "left-[-100%]"
            }`}
          >
            {Object.keys(rawConfigs)
              ?.filter((item) => item !== "logged user")
              ?.map((menuName, index) => (
                <div
                  key={index}
                  className="relative w-full cursor-pointer uppercase text-white"
                >
                  <li
                    className={cn(
                      "relative w-full whitespace-nowrap hover:text-pri-clr-orange ",
                    )}
                    onClick={() =>
                      finYearID && finYearName
                        ? (setaAtiveHoveMenuItem(menuName),
                          setaAtiveHoveMenuShow(!activeHoveMenuShow))
                        : handleNavbarAccess()
                    }
                  >
                    <p className="flex w-full  items-center justify-between gap-2 border-b-[1px] border-b-[#c6c6c6] px-6 py-3 ">
                      {menuName}
                      {activeHoveMenuItem === menuName &&
                      activeHoveMenuShow &&
                      menuName !== "logged user" ? (
                        <img
                          src={chevronDownIcon}
                          alt="i4invest"
                          className="rotate-180"
                        />
                      ) : (
                        <img
                          src={chevronDownIcon}
                          alt="i4invest"
                          className=""
                        />
                      )}
                    </p>

                    {activeHoveMenuItem === menuName &&
                      activeHoveMenuShow &&
                      menuName !== "logged user" && (
                        <>
                          <DropdownListMobile
                            data={rawConfigs[menuName]}
                            handleClose={() => setaAtiveHoveMenuItem("")}
                            setNavToggle={setNavToggle}
                            navToggle={navToggle}
                            routeName={rawConfigs[menuName]}
                            subscriberName={subscriberName}
                          />
                        </>
                      )}
                  </li>
                </div>
              ))}
            {Object.keys(rawConfigs)
              .filter((item) => item === "logged user")
              .map((menuName, index) => (
                <div
                  key={index}
                  className="relative w-full cursor-pointer uppercase text-white"
                >
                  {menuName === "logged user" && (
                    <>
                      {sessionStorage.getItem("subscriberToken") && (
                        <li
                          className={cn(
                            " w-full whitespace-nowrap hover:text-pri-clr-orange ",
                          )}
                        >
                          <div
                            onClick={() =>
                              finYearID && finYearName
                                ? (setaAtiveHoveMenuItem(menuName),
                                  setaAtiveHoveMenuShow(!activeHoveMenuShow))
                                : handleNavbarAccess()
                            }
                            className="flex w-full justify-between border-b-[1px] border-b-[#c6c6c6] px-6 py-3  "
                          >
                            <div className="relative flex  items-center gap-0 space-x-2 ">
                              {selectedRadio === "member" && (
                                <p
                                  className=" text-[16px]  text-white"
                                  onClick={() =>
                                    finYearID && finYearName
                                      ? false
                                      : handleNavbarAccess()
                                  }
                                >
                                  {subscriberName}
                                </p>
                              )}
                              {selectedRadio === "family" && (
                                <p
                                  className=" text-[16px] text-white"
                                  onClick={() =>
                                    finYearID && finYearName
                                      ? false
                                      : handleNavbarAccess()
                                  }
                                >
                                  {subscriberName}
                                </p>
                              )}
                              {selectedRadio === "group" && (
                                <p
                                  className=" text-[16px] text-white"
                                  onClick={() =>
                                    finYearID && finYearName
                                      ? false
                                      : handleNavbarAccess()
                                  }
                                >
                                  {subscriberName}
                                </p>
                              )}
                              <div className="flex h-[25px] w-[25px]  items-center rounded-sm bg-[#231c42] p-1  ">
                                {selectedRadio === "member" && (
                                  <>
                                    <svg
                                      fill="white"
                                      width={"13px"}
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 448 512"
                                    >
                                      <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z" />
                                    </svg>
                                  </>
                                )}
                                {selectedRadio === "family" && (
                                  <svg
                                    fill="white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 640 512"
                                  >
                                    <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM609.3 512H471.4c5.4-9.4 8.6-20.3 8.6-32v-8c0-60.7-27.1-115.2-69.8-151.8c2.4-.1 4.7-.2 7.1-.2h61.4C567.8 320 640 392.2 640 481.3c0 17-13.8 30.7-30.7 30.7zM432 256c-31 0-59-12.6-79.3-32.9C372.4 196.5 384 163.6 384 128c0-26.8-6.6-52.1-18.3-74.3C384.3 40.1 407.2 32 432 32c61.9 0 112 50.1 112 112s-50.1 112-112 112z" />
                                  </svg>
                                )}

                                {selectedRadio === "group" && (
                                  <svg
                                    fill="white"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 640 512"
                                  >
                                    <path d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z" />
                                  </svg>
                                )}
                              </div>
                            </div>
                            {activeHoveMenuItem === menuName &&
                            activeHoveMenuShow &&
                            menuName === "logged user" &&
                            selectedRadio ? (
                              <img
                                src={chevronDownIcon}
                                alt="i4invest"
                                className="rotate-180"
                              />
                            ) : (
                              <img
                                src={chevronDownIcon}
                                alt="i4invest"
                                className=""
                              />
                            )}
                          </div>

                          {activeHoveMenuItem === menuName &&
                            activeHoveMenuShow &&
                            menuName === "logged user" &&
                            selectedRadio && (
                              <div className="">
                                <DropdownListMobile
                                  selectedRadio={selectedRadio}
                                  data={rawConfigs[menuName]}
                                  setNavToggle={setNavToggle}
                                  navToggle={navToggle}
                                  handleClose={() => setaAtiveHoveMenuItem("")}
                                  subscriberName={subscriberName}
                                  routeName={menuName}
                                />
                              </div>
                            )}
                        </li>
                      )}
                      <li
                        className={cn(
                          "relative w-full whitespace-nowrap hover:text-pri-clr-orange ",
                        )}
                        onClick={() =>
                          finYearID && finYearName
                            ? (setaAtiveHoveMenuItem("finyear"),
                              setaAtiveHoveMenuShow(!activeHoveMenuShow))
                            : handleNavbarAccess()
                        }
                      >
                        {selectedRadio === "group" ||
                        selectedRadio === "family" ? (
                          <div className=" w-full items-center">
                            <div className="flex w-full items-center justify-between border-b-[1px] border-b-[#c6c6c6] px-6 py-3 ">
                              <p className="mr-2">{finYearName}</p>
                              {activeHoveMenuItem === "finyear" &&
                              activeHoveMenuShow ? (
                                <img
                                  src={chevronDownIcon}
                                  alt="i4invest"
                                  className="rotate-180"
                                />
                              ) : (
                                <img
                                  src={chevronDownIcon}
                                  alt="i4invest"
                                  className=""
                                />
                              )}
                            </div>

                            {activeHoveMenuItem === "finyear" &&
                              activeHoveMenuShow && (
                                <DropdownListMobile
                                  data={rawConfig?.finyear}
                                  handleClose={() => setaAtiveHoveMenuItem("")}
                                  setNavToggle={setNavToggle}
                                  navToggle={navToggle}
                                  routeName="finyear"
                                  workingFinYear={finYearName}
                                  finYearList={finYearList}
                                  subscriberName={subscriberName}
                                />
                              )}
                          </div>
                        ) : (
                          <div className=" w-full items-center">
                            <div className="flex w-full items-center justify-between border-b-[1px] border-b-[#c6c6c6] px-6 py-3 ">
                              <p className="mr-2">{finYearName}</p>
                              {activeHoveMenuItem === "finyear" &&
                              activeHoveMenuShow ? (
                                <img
                                  src={chevronDownIcon}
                                  alt="i4invest"
                                  className="rotate-180"
                                />
                              ) : (
                                <img
                                  src={chevronDownIcon}
                                  alt="i4invest"
                                  className=""
                                />
                              )}
                            </div>

                            {activeHoveMenuItem === "finyear" &&
                              activeHoveMenuShow && (
                                <DropdownListMobile
                                  data={rawConfig?.finyear}
                                  handleClose={() => setaAtiveHoveMenuItem("")}
                                  setNavToggle={setNavToggle}
                                  navToggle={navToggle}
                                  routeName="finyear"
                                  workingFinYear={finYearName}
                                  finYearList={finYearList}
                                  subscriberName={subscriberName}
                                />
                              )}
                          </div>
                        )}
                      </li>
                      <li
                        className={cn(
                          "relative w-full whitespace-nowrap hover:text-pri-clr-orange ",
                        )}
                        onClick={() =>
                          finYearID && finYearName
                            ? (setaAtiveHoveMenuItem(menuName),
                              setaAtiveHoveMenuShow(!activeHoveMenuShow))
                            : handleNavbarAccess()
                        }
                      >
                        {!selectedRadio && (
                          <div className="flex w-full items-center justify-between border-b-[1px] border-b-[#c6c6c6] px-6 py-3">
                            <p className="mr-2">
                              {menuName === "logged user"
                                ? firstName + " " + lastName
                                : menuName}
                            </p>
                            {activeHoveMenuItem === menuName &&
                            activeHoveMenuShow &&
                            menuName === "logged user" ? (
                              <img
                                src={chevronDownIcon}
                                alt="i4invest"
                                className="rotate-180"
                              />
                            ) : (
                              <img
                                src={chevronDownIcon}
                                alt="i4invest"
                                className=""
                              />
                            )}
                          </div>
                        )}
                        {selectedRadio && (
                          <div className=" w-full items-center justify-between border-b-[1px] border-b-[#c6c6c6] px-6 py-3">
                            <p className="mr-2">
                              {menuName === "logged user"
                                ? firstName + " " + lastName
                                : menuName}
                            </p>
                            <p className=" text-[12px] italic">
                              ( Currently logged in as {subscriberName} )
                            </p>
                          </div>
                        )}
                        {activeHoveMenuItem === menuName &&
                          activeHoveMenuShow &&
                          menuName === "logged user" && (
                            <>
                              {!selectedRadio && (
                                <DropdownListMobile
                                  data={rawConfigs[menuName]}
                                  handleClose={() => setaAtiveHoveMenuItem("")}
                                  setNavToggle={setNavToggle}
                                  navToggle={navToggle}
                                  routeName={menuName}
                                />
                              )}
                            </>
                          )}
                      </li>
                    </>
                  )}
                </div>
              ))}
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default AuthNavbar;
